// extracted by mini-css-extract-plugin
module.exports = {"schoolPage":"DrivingSchoolPage_schoolPage__2CxGZ","schoolTopContainer":"DrivingSchoolPage_schoolTopContainer__2Y_en"};